var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.62 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#2772af;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M83.87,6.4c-3,5.6-6.9,10.7-11.1,15.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M93.07,8.9c-2.6,4.8-6.2,9.5-9.7,13.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M143.27,63.2c-4.8-2.5-9.6-6.1-13.8-9.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M144.37,58c-5.1-3.2-4.5-2.9-8.7-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M92.27,71.7c-3.4-1.1-6.6-5.6-7.9-8.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M101.07,13.8c-2.1,3.3-4.6,6.5-7,9.5"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 18.67,
    cy: 41.1,
    r: 4.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M32.87,49.8c.5,4.1-.9,7.1-3.9,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M36.67,26.7c4.5,6.5,6.4,15,3.6,22.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M162.17,38.3c4-.3,6.1-.9,9.4-2.9,3-1.8,5.7-2.6,10.1-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M183.27,51.9c-4.7-1.2-8-2.7-11.5-4.8-3.3-2-5.7-2.6-9.7-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M172.07,41.4l-10-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M161.97,34c.1,4.7,0,9.2-.2,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M160.47,34.2c-6-.2-12.2-.8-17.4-1.7-26.5-4.9-55.8-12.4-88.2-9-15.2,1.6-22.5,2.1-41.3,10.3-2.6,1.1-8,4-10.1,6-8.1,7.8,19.7,17.8,25,19.4,12.5,3.7,25.5,5,38.5,5.4,15.8,.6,34.7-3.8,49.9-8.4,14.5-4.3,28.3-8.2,43.4-7.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M160.27,48.4c9.3,.3,19.7,9.5,25.9,12.7,1.6,.9,3.2,1.5,5.4,2,1.1,.2-15-18.8-14.4-22.1,.6-3.4,2.7-7.2,5.1-10.6,4.4-6.2,9.7-11.3,9-11.5-1.7-.4-3.7,.8-5.1,1.9-4.8,3.6-7.7,6.1-12.4,9-3.6,2.2-9.3,3.7-13.3,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M44.67,52.7s10.6-1.4,15.7-1.4,6.4,.9,6.4,.9h0c-1.3,1.5-1.4,1.7-2.1,2.3-1.3,1.2-2.8,2.1-4.5,2.7l-2.8,1.1s-6.3-.7-10.2-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M55.77,23.4c8.6-4,15.5-15.1,20.7-21.4,0,0,2.3,.8,4.3,1.5,11.4,3.7,23.8,9.4,28.8,21,.2,.4,.3,.8,.5,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M132.87,30.5s7.8-4.3,9-4.4,3.2,.2,4.4,1,2,2.3,1.9,2.6c-.2,.3-5.1,2.9-5.1,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M121.07,54.9c2.8,2.1,5.6,4.2,8.4,6.3,2.5,1.9,5,4.3,8.1,5.3,2.7,.9,5.4-.2,6.1-3.1,.6-2.9,.9-6,1-9,.1-1.3,0-5.1,1.9-5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M81.17,63.9c.5,1.4,2.8,7.5,3.7,9,2.8,4.8,6.3,7.3,11.1,10.1,.3-.4-1.5-3.7-.1-7.9,1.4-4.1,2.4-4.3,3.8-5.7,0,0-5.2-3.3-8.1-4.5-2.7-1.2-4.6-1.7-4.6-1.7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayling);
export default __webpack_public_path__ + "static/media/Grayling.d9928780e9524987b4fad68a476aa02f.svg";
export { ForwardRef as ReactComponent };